<script setup lang="ts">
import { PrimaryButton, AltPrimaryButton } from '@hfc/ui-core';
import { useUrlHelper } from '@/page/infrastructure/composition/useUrlHelper';

const props = withDefaults(defineProps<{
  variant?: boolean,
  targetBlank?: boolean,
  url?: string
}>(), {
  variant: false,
  targetBlank: false
});

const { getIaFQuoteUrl } = useUrlHelper();

const target = props.targetBlank ? '_blank' : '_self';
const url = props.url ? props.url : getIaFQuoteUrl();

</script>

<template>
  <AltPrimaryButton v-if="variant" :target="target" v-bind="$props" :href="url">
    <slot/>
  </AltPrimaryButton>
  <PrimaryButton v-else :target="target" v-bind="$props" :href="url">
    <slot/>
  </PrimaryButton>
</template>
